<template>
  <div class="test-buy-balance-page">
    <div class="page-header">
      <h2>
        {{ $t("testbuy.test_purchase_billing") }}
        <span style="float:right; font-size:14px; margin-top:0;">
          {{ $t("testbuy.as_of") + ' : ' + $moment(new Date()).local().format('YYYY-MM-DD HH:mm:ss') }}
        </span>
      </h2>
    </div>

    <div class="test-buy-balance-overview">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="test-buy-balance-overview-box">
            <div class="test-buy-balance-row1">
              <div class="test-buy-balance-overview-box-header">
                <h2>{{ $t("testbuy.consumption") }}</h2>
              </div>
              <div class="test-buy-balance-overview-box-body">
                <el-col :span="12">
                  <h4 class="colorgrey">{{ millonFormat((balance.recharge * 1).toFixed(2)) }}</h4>
                  <h5>{{ $t("testbuy.total_recharge_amount") }}</h5>
                </el-col>
                <el-col :span="12">
                  <h4 :class="balance.totalAmount * 1 >=0 ? 'colorgreen' : 'colorred'">{{ millonFormat((balance.totalAmount * 1).toFixed(2)) }}</h4>
                  <h5>{{ $t("testbuy.account_balance") }}</h5>
                </el-col>
              </div>
            </div>
            <div class="test-buy-balance-row2">
              <el-col :span="6">
                <div>
                  <h2>{{ millonFormat((balance.orderPrice * 1).toFixed(2)) }}</h2>
                  <h3>{{ $t("testbuy.total_product_cost") }}</h3>
                </div>
              </el-col>
              <el-col :span="6">
                <div>
                  <h2>{{ millonFormat((balance.postage * 1).toFixed(2)) }}</h2>
                  <h3>{{ $t("testbuy.total_shipping_fee") }}</h3>
                </div>
              </el-col>
              <el-col :span="6">
                <div>
                  <h2>{{ millonFormat((balance.servicePrice * 1).toFixed(2)) }}</h2>
                  <h3>{{ $t("testbuy.total_service_fee") }}</h3>
                </div>
              </el-col>
              <el-col :span="6">
                <div>
                  <h2>{{ millonFormat((balance.tax * 1).toFixed(2)) }}</h2>
                  <h3>{{ $t("testbuy.total_tax_fee") }}</h3>
                </div>
              </el-col>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="test-buy-balance-overview-box">
            <div class="test-buy-balance-overview-box-header">
              <h2>{{ $t("testbuy.billing_history") }}</h2>
            </div>
            <div class="test-buy-balance-overview-box-body mt0">
              <div class="dashboard-chart-bar-container">
                <div class="dashboard-chart-bar-component" id="barchartid3"></div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="test-buy-balance-lists">
      <div class="page-header">
        <h2>{{ $t("testbuy.test_purchase_consumption_details") }}
          <!-- <el-select v-model="currentmonth" size="mini" clearable class="test-buy-selectmonth" @change="getTestbuyList">
            <el-option
              v-for="item in month"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select> -->
          <!-- <el-select v-model="activestatus" size="mini" clearable class="test-buy-selectmonth" @change="getTestbuyList">
            <el-option
              v-for="item in statustype"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select> -->
        </h2>
      </div>
      <div class="test-buy-table">
        <el-table
          :data="balancelists"
          v-loading="loading" 
          size="mini">
          <el-table-column :label="$t('testbuy.date')" prop="time" width="150">
            <template slot-scope="scope">
              {{ scope.row.time != '' && scope.row.time != null && scope.row.time != 'null' ? $moment(scope.row.time).format('YYYY-MM-DD') : ''}}
            </template>
          </el-table-column>
          <el-table-column label="TBID" prop="testId" width="150"></el-table-column>
          <el-table-column :label="$t('testbuy.description')" prop="typeofChange" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('testbuy.product_name')" prop="productName" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('testbuy.channel')" prop="channel" width="80">
            <template slot-scope="scope">
              <i class="channelicon" :class="setChannel(scope.row.channel).src"></i>
            </template>
          </el-table-column>
          <el-table-column :label="$t('testbuy.fee')" prop="amount" align="right" width="100">
            <template slot-scope="scope">
              <span :style="scope.row.amount * 1 > 0 ? 'color: #006633;' : ''">{{ millonFormat((scope.row.amount * 1), true) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="lists" 
          v-if="false"
          v-loading="loading" 
          size="mini" 
          :cell-style="getTableCellStyle">
          <el-table-column label="TBID" prop="testId" width="80"></el-table-column>
          <el-table-column label="ASSETID" prop="assetId" width="80"></el-table-column>
          <el-table-column label="订单号" prop="orderNumer" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column label="备注" prop="note" show-overflow-tooltip></el-table-column>
          <el-table-column label="产品名称" prop="productName" show-overflow-tooltip></el-table-column>
          <el-table-column label="套餐名称" prop="skuMap" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="渠道" prop="channel" width="80">
            <template slot-scope="scope">
              <i class="channelicon" :class="setChannel(scope.row.channel).src"></i>
            </template>
          </el-table-column>
          <el-table-column label="商品费用" prop="commodityPrice" width="100"></el-table-column>
          <el-table-column label="运费" prop="postage" width="80"></el-table-column>
          <el-table-column label="税费" prop="tax" width="80"></el-table-column>
          <el-table-column label="服务费" prop="service" width="80"></el-table-column>
          <el-table-column label="小计" prop="orderPrice" width="80"></el-table-column>
        </el-table>
      </div>
      <div class="pagewrap">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="size"
          layout="total, prev, pager, next, sizes"
          :total="pagingtotal">
        </el-pagination>      
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      currentmonth: '',
      activestatus: '',
      taskid: this.getCurrentInfo().taskid,
      loading: false,
      balance: {
        totalAmount: '',
        recharge: '',
        orderPrice: '',
        postage: '',
        tax: '',
        servicePrice: ''
      },
      statustype: [{
        name: '状态',
        value: ''
      },{
        name: '待下单',
        value: 0
      },{
        name: '待发货',
        value: 1
      },{
        name: '物流中',
        value: 2
      },{
        name: '报告制作中',
        value: 3
      },{
        name: '报告已交付',
        value: '7,10,11'
      },{
        name: '退货中',
        value: 5
      },{
        name: '返还中',
        value: 6
      }],
      month: [{
        name: '时间',
        value: ''
      },{
        name: this.$moment(this.today).format('YYYY-MM'),
        value: this.$moment(this.today).format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(1, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(1, 'months').format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(2, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(2, 'months').format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(3, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(3, 'months').format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(4, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(4, 'months').format('YYYY-MM')
      },{
        name: this.$moment(this.today).subtract(5, 'months').format('YYYY-MM'),
        value: this.$moment(this.today).subtract(5, 'months').format('YYYY-MM')
      }],
      lists: [],
      page: 1,
      size: 25,
      order: '',
      search: '',
      pagingtotal: 0,
      balancelists: []
    }
  },

  mounted(){
    let that = this
    that.testBuyDashboard()
    // that.getTestbuyList()
    that.getBalance()
  },

  methods: {

    /**
     * 修改每页显示条数
     */
     handleSizeChange: function(val){
      this.size = val
      this.page = 1
      this.getBalance()
    },

    /**
     * 翻页
     */
    handleCurrentChange: function(val){
      this.page = val
      this.getBalance()
    },

    /**
     * 历史账单详情
     */
    initBarChartAuthorized: function(dataitem, datavalue, cid){
      if(document.getElementById(cid) === null) return
      let myBarChart = this.$echarts.init(document.getElementById(cid))
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        grid: {
          left: 20,
          top: 20,
          bottom: 20,
          right:20,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            fontSize: 10
          },
          axisTick: {
            alignWithLabel: true,
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          data: dataitem
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: false,
            color: 'rgba(51,51,51,.4)',
            interval: 'auto',
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          data: datavalue,
          type: 'bar',
          barWidth: '30',
          label: {
            show: false,
            position: 'top',
            // formatter: function (params) {
            //   var tar = params[1];
            //   return tar.name + '<br/>' + tar.seriesName + ' : ' + tar.value;
            // }
          }
        }],
        color: ['#7290F2', '#F47373', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9']
      })
      $(window).resize(function () {
          myBarChart.resize();
      });
    },

    getSummaries: function(param){
      let that = this
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 1) {
          sums[index] = '';
          return;
        }
        if (index === 2) {
          sums[index] = '';
          return;
        }
        if (index === 4) {
          sums[index] = '';
          return;
        }
        if (index === 11) {
          sums[index] = '';
          return;
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              let _n = (prev + curr) * 1
              return _n
            } else {
              let _m = prev
              return _m
            }
          }, 0)
          sums[index] = that.millonFormat(sums[index].toFixed(2))
        } else {
          sums[index] = ''
        }
      });

      return sums

    },

    /**
     * 测买记录详情
     */
    getTestbuyList: function(){
      let that = this
      that.loading = true
      let url = that.API_URL + '/v3/price/testbuy/paging?taskId=' + that.taskid
      + '&page=' + that.page + '&size=' + that.size + '&time=' + that.currentmonth 
      + '&search=' + that.search + '&order=' + that.order + '&status=' + that.activestatus
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('getTestbuyList', rex)
          that.lists = rex.results[1]
          that.pagingtotal = rex.results[0][0].Count
          that.lists.forEach(item => {
            item.commodityPrice = that.millonFormat((item.commodityPrice *1).toFixed(2))
            item.postage = that.millonFormat((item.postage *1).toFixed(2))
            item.tax = that.millonFormat(item.tax == null ? 0.00 : (item.tax *1).toFixed(2))
            item.service = that.millonFormat(!item.service ? '0.00' : (item.service *1).toFixed(2))
            item.orderPrice = that.millonFormat((item.orderPrice *1).toFixed(2))
          })
          that.loading = false
        },
        error: function(response) {
          console.log('getTestbuyList', response)
        }
      })
    },

    /**
     * 测买图表
     */
    testBuyDashboard: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/dashboard?taskId=' + that.taskid
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('testBuyDashboard', rex)
          that.balance.recharge = Math.abs(rex.results[5][1][0].recharge * 1)
          that.balance.totalAmount = rex.results[5][0][0].totalAmount * 1
          that.balance.orderPrice = Math.abs(rex.results[5][2][0].orderPrice * 1)
          that.balance.postage = Math.abs(rex.results[5][3][0].postage * 1)
          that.balance.tax = Math.abs(rex.results[5][4][0].tax * 1)
          that.balance.servicePrice = Math.abs(rex.results[5][5][0].servicePrice * 1)
          let xdata = []
          let ydata = []
          for(let i=0; i<rex.results[4][2].length; i++){
            xdata.push(rex.results[4][2][i].months)
            ydata.push(Math.abs(rex.results[4][2][i].monthPrice))
          }
          that.initBarChartAuthorized(xdata, ydata, 'barchartid3')          
        },
        error: function(response) {
          console.log('testBuyDashboard', response)
        }
      })
    },

    /**
     * 自定义排序
     */
    sortTableList: function(column){
      let that = this
      if(column.order == "ascending"){
        switch(column.prop) {
          case 'commodityPrice':
            that.order = '40'
            break
          case 'orderPrice':
            that.order = '00'
            break
          case 'finishTime':
            that.order = '50'
            break
        }
      }
      if(column.order == "descending"){
        switch(column.prop) {
          case 'commodityPrice':
            that.order = '41'
            break
          case 'orderPrice':
            that.order = '01'
            break
          case 'finishTime':
            that.order = '51'
            break
        }
      }
      if(column.order == null){
        that.order = ''
      }
      that.getTestbuyList()
    },

    /**
     * 账单明细
     * price/testbuy/pricePaging
     */
    getBalance: function(){
      let that = this
      that.loading = true
      let url = that.API_URL + '/v3/price/testbuy/pricePaging?taskId=' + that.taskid
      + '&page=' + that.page + '&size=' + that.size
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('getBalance', rex)
          that.balancelists = rex.results[1]
          that.pagingtotal = rex.results[0][0].Count
          that.loading = false
        },
        error: function(response) {
          console.log('getBalance', response)
        }
      })
    },

  }
}
</script>